import { GetterTree } from "vuex";
import { RootState } from "@/store/interfaces/root";
import { CompanyState, CompanyGetters } from "@/store/interfaces/company";
import { GetterTypes } from "./getter-types";

export const getters: GetterTree<CompanyState, RootState> & CompanyGetters = {
  /**
    Get wizard from company module state
    @param state - company module state
    @returns - {
      status: boolean;
      didInvalidate: boolean;
      companyId: string;
      companyName: string;
      companyUrl: string;
      receivedAt: number;
      connectionError: boolean;
    }
  */
  [GetterTypes.COMPANY_GET_WIZARD](state) {
    return state.wizard;
  },

  /**
    Get company from company module state
    @param state - company module state
    @returns - {
      status: boolean;
      didInvalidate: boolean;
      companyId: string;
      companyName: string;
      companyUrl: string;
      receivedAt: number;
      connectionError: boolean;
    }
  */
  [GetterTypes.COMPANY_GET_COMPANY](state) {
    return state.company;
  }
};
